import I, { ImmutableObject } from 'seamless-immutable';
import { PurchaseNotificationsStoreEnum } from './types';

export function purchaseNotificationsStoreAdapter(): ImmutableObject<Record<string, any>> {
  return I({
    [PurchaseNotificationsStoreEnum.PURCHASE_NOTIFICATIONS]: []
  });
}
